import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import Media from 'webutils/media/media'
import config from 'emun.on-demand/lib/_config'
import modals from 'webmodals/modals'

class MediaBrowserController {
    constructor() {
        basicController(this)
        const $ctrl = this;
        console.warn('MediaBrowserController', $ctrl);
        let context = ($ctrl.context || `Designer`);
        let request = {
            criteria: $ctrl.criteria || {},
            tagCriteria: $ctrl.tagCriteria || $ctrl.tags || {},
        };

        let aqOptions = {
            pageSize: 48,
            url: `QueryMedia.json?Context=${context}&Fields=Id,Label,Description,Realm,ContentType,Height,Width,Url`,
            orderBy: '-CreatedOn,Id',
            autoLoad: true,
            append: !!$ctrl.append,
            criteria: request.criteria,
            tagCriteria: request.tagCriteria,
            hideLeftNav: true,
            scrub(response) {
                response.data.results = response.data.results.map(m => new Media(m));
                console.debug('media', response.data.results);
            }
        }

        $ctrl.realms = {
            Design: 'Designs',
            Clipart: 'Clipart (svg)',
            media: 'Images (jpg/png)'
        }
        $ctrl.query = new AutoQuery(aqOptions);
        $ctrl.bus = $ctrl.query.bus;
    }

    setRealm(realm) {
        const $ctrl = this;
        $ctrl.query.criteria.realm = realm;
        $ctrl.query.load(true);
    }

    $onDestroy() {
        this.query.dispose();
    }
}

export default MediaBrowserController;